import { getItemObject, removeItem } from './storage'
export function getUserInfo () {
  return getItemObject('userinfo')
}  
export function clearUserInfo () {
  return removeItem('userinfo')
}